import { GetVariableValue } from '../hooks'
import { BrandingColorType, VariableSourceType } from './index'

export const createLogo = async (
  screen: HTMLElement,
  fontFamily: string,
  hasText: boolean,
  getVariableValue: GetVariableValue,
  goHome?: () => void
) => {
  const logo = document.createElement('div')
  logo.id = 'logo'
  screen.appendChild(logo)

  const imageElement = document.createElement('img')
  const imageValue = await getVariableValue({
    source: {
      type: VariableSourceType.globalVariable,
      variableName: 'applicationIcon',
    },
  })
  const url = imageValue?.url || ''
  imageElement.setAttribute('src', url)
  logo.appendChild(imageElement)

  if (hasText) {
    const onSurface = await getVariableValue({ colorConstant: `@${BrandingColorType.onSurface}` })
    const textElement = document.createElement('div')
    textElement.style.color = onSurface
    textElement.style.fontFamily = fontFamily
    textElement.innerText = await getVariableValue({
      source: { type: VariableSourceType.globalVariable, variableName: 'applicationName' },
    })
    logo.appendChild(textElement)
  }

  if (goHome) {
    logo.className = 'clickable'
    logo.onclick = () => goHome()
  }
}
